import { ReactNode } from 'react';

import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import ErrorType from './errorType';
import ErrorView from './errorView';

interface SectionErrorBoundaryProps {
	children: ReactNode;
	/** Optional reset keys — boundary resets when any key changes (e.g. route path) */
	resetKeys?: unknown[];
}

const SectionFallback = ({ resetErrorBoundary }: FallbackProps) => (
	<ErrorView type={ErrorType.Other} onAction={resetErrorBoundary} />
);

/**
 * Reusable section-level error boundary for wrapping risky UI islands.
 *
 * Use this around components that are known to be unstable or that render
 * third-party content. Do NOT wrap every component — only targeted sections.
 *
 * @example
 *   <SectionErrorBoundary>
 *     <UnstableWidget />
 *   </SectionErrorBoundary>
 */
const SectionErrorBoundary = ({ children, resetKeys }: SectionErrorBoundaryProps) => {
	return (
		<ErrorBoundary
			FallbackComponent={SectionFallback}
			resetKeys={resetKeys}
			onError={(error, info) => console.error('Section error:', error, info)}
		>
			{children}
		</ErrorBoundary>
	);
};

export default SectionErrorBoundary;
